import * as React from 'react';
import * as classes from './tooltip.scss';

export interface TooltipProperties {
  readonly text?: string;
  readonly icon?: string;
  readonly side?: string;
  readonly topOrBottom?: string;
  readonly relative?: boolean;
  readonly absoluteText?: boolean;
}

interface TooltipState {
  isTipVisible: boolean;
}

export class TooltipComponent extends React.Component<TooltipProperties, TooltipState> {
  state = { isTipVisible: false };

  constructor(props: TooltipProperties) {
    super(props);
  }

  groupClasses() {
    const mergedClasses = [classes.tooltiptext];
    mergedClasses.push(this.props.side ? classes[this.props.side.toLowerCase()] : classes.right);
    mergedClasses.push(this.props.topOrBottom === 'bottom' ? classes.bottom : classes.top);
    mergedClasses.push(this.state.isTipVisible ? classes.visible : classes.hidden);
    mergedClasses.push(this.props.absoluteText === undefined || this.props.absoluteText ? classes.absolute : '');

    return mergedClasses.join(' ');
  }

  toggleTooltip = () => {
    this.setState((prevState: TooltipState) => {
      return { isTipVisible: !prevState.isTipVisible };
    });
  };

  render() {
    return (
      <span className={classes.tooltip}>
        <i
          className={`fas fa-fw ${this.props.icon || 'fa-info-circle'} pointer`}
          onMouseOver={this.toggleTooltip}
          onMouseLeave={this.toggleTooltip}
        />
        <span className={this.groupClasses()}>{this.props.text || this.props.children}</span>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/tooltip/tooltip.component.tsx